import React from 'react';

export const DisplayValue = ({ value }: { value: string | number }) => <>{value}</>;
